// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Image from 'components/Image/Image'

class PageHeader extends React.Component {
	renderContent() {
		const { translate } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		let viewsText = ''

		if ( 'post' == page.type ) {
			// Views:
			let views = parseInt( page.views, 10 )

			if ( ! views ) {
				views = 0
			}

			views++ // Include this view.

			if ( '1' == views ) {
				viewsText = `1 View`
			} else {
				viewsText = `${views} Views`
			}
		}

		return (
			<div className="page-header-content">
				<div className="-title">
					{ page.category.primary.name &&
						<p className="-category" dangerouslySetInnerHTML={ { __html: page.category.primary.name } } />
					}

					<h1 dangerouslySetInnerHTML={ { __html: page.title.raw } } />

					{ page.subtitle.rendered &&
						<h2 dangerouslySetInnerHTML={ { __html: page.subtitle.rendered } } />
					}

					{ 'post' == page.type &&
						<div className="-author-date">
							<div className="-author">{ page.author.name }</div>

							{ page.author && page.date.display &&
								<div className="-divider"> | </div>
							}

							<div className="-date">{ page.date.display }</div>

							{ viewsText &&
								<div className="-divider"> | </div>
							}

							{ viewsText &&
								<div className="-views">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 00-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 000-17.47C428.89 172.28 347.8 112 255.66 112z" ></path><circle cx="256" cy="256" r="80" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" ></circle></svg>
									{ viewsText }
								</div>
							}
						</div>
					}
				</div>
			</div>
		)
	}

	renderImage() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page
		let wrapClass = 'page-header-image'
		const { params, path } = this.props.match

		if ( ! page ) {
			return (
				<div className="page-header-image">
					<div className="-inner">

					</div>
				</div>
			)
		}

		// Show thin images at full width:
		if ( page.featured_image.aspect_ratio > 1.77 ) {
			wrapClass += ' is-extra-wide'
		}

		const imageWrapStyle = {
			paddingBottom: 100 / page.featured_image.aspect_ratio + '%'
		}

		const featuredImage = page.featured_image

		if ( featuredImage.url ) {
			return (
				<div className={ wrapClass }>
					<div className="-inner">
						<Image
							thumb={ featuredImage.thumb }
							url={ featuredImage.url }
							srcset={ featuredImage.srcset }
							sizes={ `(max-width: ${siteData.mobile_max_width}) 100vw, 1100px` }
							alt={ featuredImage.alt }
							focalPoint={ featuredImage.focal_point }
							width={ featuredImage.width }
							height={ featuredImage.height }
							wrapStyle={ imageWrapStyle }
						/>
					</div>
				</div>
			)
		}

		return null
	}

	render() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		const className = page.page_header_style ? page.page_header_style : 'page-header'

		if ( this.props.isLoading ) {
			return null
		} else {
			return (
				<div className={ className }>
					{ this.renderImage() }
					{ this.renderContent() }
				</div>
			)
		}

	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( PageHeader )
